var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.64981 2.99998C8.64981 2.64099 8.35879 2.34998 7.9998 2.34998C7.64082 2.34998 7.3498 2.64099 7.3498 2.99998V7.34998H3.00059C2.6416 7.34998 2.35059 7.64099 2.35059 7.99998C2.35059 8.35896 2.6416 8.64998 3.00059 8.64998H7.3498V13C7.3498 13.359 7.64082 13.65 7.9998 13.65C8.35879 13.65 8.64981 13.359 8.64981 13V8.64998H13.0006C13.3596 8.64998 13.6506 8.35896 13.6506 7.99998C13.6506 7.64099 13.3596 7.34998 13.0006 7.34998H8.64981V2.99998Z","fill":"currentColor"}));
}

Plus.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Plus;

Plus.default = Plus;
